import React, { useEffect } from 'react';
import { Toaster } from 'sonner';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Featured } from './components/Featured';
import { PullQuote } from './components/PullQuote';
import { Interview } from './components/Interview';
import { SectionsGrid } from './components/SectionsGrid';
import { Contributors } from './components/Contributors';
import { Subscribe } from './components/Subscribe';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Ensure RTL direction on the document
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'he';
  }, []);
  return <div className="min-h-screen bg-paper text-ink font-sans selection:bg-vermillion selection:text-paper paper-texture" dir="rtl" data-id="element-0">
      <Toaster position="bottom-center" data-id="element-1" />

      {/* Outer framing for print feel */}
      <div className="fixed inset-0 pointer-events-none border-[12px] md:border-[24px] border-paper z-50 mix-blend-normal" data-id="element-2" />
      <div className="fixed inset-[12px] md:inset-[24px] pointer-events-none border border-ink/10 z-50" data-id="element-3" />

      <main className="relative pb-24 md:pb-0" data-id="element-4">
        <Nav data-id="element-5" />
        <Hero data-id="element-6" />
        <Featured data-id="element-7" />
        <PullQuote data-id="element-8" />
        <Interview data-id="element-9" />
        <SectionsGrid data-id="element-10" />
        <Contributors data-id="element-11" />
        <Subscribe data-id="element-12" />
        <Footer data-id="element-13" />
      </main>
    </div>;
}